import { Modal } from "react-bootstrap";
import remove from "../../assests/noto_warning.svg";
import checkActive from "../../assests/svg/checkActive.svg";
import styles from "./changeOwner.module.scss";
import ThemeButton from "../theme/ThemeButton";
interface IProps {
  confirm: (id: any) => void;
  handleToggle: () => void;
  title: string;
  show: boolean;
  size?: any;
  loading?: boolean;
  heading?: string;
}
const ChangeOwnerConfirmationModal = ({
  confirm,
  handleToggle,
  title,
  show,
  size = "lg",
  loading,
  heading,
}: IProps) => {
  return (
    <Modal
      show={show}
      onHide={handleToggle}
      size={size}
      className={styles.confirmationModal}
      centered
    >
      <Modal.Body>
        <div className={styles.modalContent}>
          <div className={styles.modalTitle}>
            <span className={styles.icn}>
              <img src={remove} alt="Delete " />
            </span>
            <h2>{heading}</h2>
            <h4>{title}</h4>
          </div>
          <Modal.Footer className={styles.FooterModal}>
            <ThemeButton
              variant="secondary"
              className="primary  commonBtn"
              onClick={handleToggle}
            >
              Cancel
            </ThemeButton>
            <ThemeButton
              variant="primary"
              className="primary footerModalBtn commonBtn"
              onClick={confirm}
              loading={loading}
            >
              Continue
            </ThemeButton>
          </Modal.Footer>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ChangeOwnerConfirmationModal;
